import React, { Component } from 'react';

export default class ZDropdownMenu extends Component {

    //Props List
    /*
        id,
        className,
        menuItems,
        isBlocked
    */

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            sequenceNum: 0
        }

        this.nextSequence = this.nextSequence.bind(this);

        this.generateMenuItems = this.generateMenuItems.bind(this);
        this.renderChildren = this.renderChildren.bind(this);
    }

    componentDidMount() { }

    componentWillReceiveProps() { }

    nextSequence() {
        let self = this;

        let num = this.state.sequenceNum;

        if (this.state.sequenceNum === 2) {
            num = 0;
        } else {
            num++;
        }

        this.setState({ sequenceNum: num }, () => {
            if (num === 2) {
                setTimeout(() => {
                    self.nextSequence();
                }, 150);
            }
        });
    }

    generateMenuItems() {
        let self = this;
        if (this.props.menuItems === undefined || this.props.menuItems === null) {
            return null;
        }

        let menuItems = [];

        if (this.props.scrollDown > 50) {
            return null;
        }

        for (var i = 0; i < this.props.menuItems.length; i++) {

            let tempItem = this.props.menuItems[i];

            if (tempItem.props.closeMenuOnClick) {
                menuItems.push((
                    <div onClick={this.nextSequence}>{tempItem}</div>
                ));
            } else {
                menuItems.push(tempItem);
            }
        }

        return menuItems;
    }

    renderChildren() {
        return React.Children.map(this.props.children, (child) => {
            return React.cloneElement(child, {
                onClick: this.nextSequence
            })
        })
    }

    render() {

        let outerClass = "zmd-dropdown-outer";
        let itemContainerClass = 'zmd-item-container';
        let blockerClass = 'zmd-blocker'

        switch (this.state.sequenceNum) {
            case 0:
                break;
            case 1:
                blockerClass += ' zmd-blocker--active';
                itemContainerClass += ' zmd-item-container--phase1';
                break;
            case 2:
                blockerClass += ' zmd-blocker--active';
                itemContainerClass += ' zmd-item-container--phase2';
                break;
        }

        if (this.props.className != undefined) {
            outerClass += ' ' + this.props.className;
        }


        let blockJsx = !this.props.isBlocked ? null :
            (
                <div className={blockerClass}
                    onClick={this.state.sequenceNum === 1 ? this.nextSequence : null}
                    onScroll={this.state.sequenceNum === 1 ? this.nextSequence : null}></div>
            )

        let menuItems = this.generateMenuItems();

        return (
            <div className={outerClass}>
                {blockJsx}
                {this.renderChildren()}
                <div className={itemContainerClass}>
                    {menuItems}
                </div>
            </div>
        );
    }
}
